<script>
	import { getContext, onDestroy } from 'svelte'
	import { validate } from '../library/scripts/validate.js'
	import { fade } from 'svelte/transition'
	import { styles } from '../library/scripts/styles.js'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import { getCookie } from '../library/scripts/cookie.js'
	import { storeFeedback } from '../library/scripts/Store.svelte'
	import Textarea from '../library/selectors/Textarea.svelte'
	import Error from '../library/selectors/Error.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Button from '../library/LayoutStuff/Button.svelte'
	import Select from '../library/selectors/SimpleSelect.svelte'

	const globals = getContext('globals')

	const fontColor = globals.colorMain
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsL = globals.fsL
	const borderColor = globals.inputBorder
	const inputBg = globals.inputBg
	const hoverText = globals.buttonSmallHover
	const bg = globals.buttonSmallBg

	const ID = getCookie('id')

	if (ID.length < 30) document.location = '#'

	//contact
	let contact

	let name
	let message
	let errorMessage
	let errorMsg
	let errorTopic
	let errorUser = false
	let topic
	let messageTitle = ''

	//timouts
	let toError

	let showShader = false
	let showThank = false

	const close_window = () => {
		storeFeedback.set(false)
	}

	const set_topic = (e) => {
		topic = e.detail.name
		switch (topic) {
			case 'feedback':
				messageTitle = 'Please write a short feedback'
				break

			case 'suggestion':
				messageTitle = 'Please add your suggestions'
				break

			case 'bug-report':
				messageTitle = 'Please write a detailed report on what went wrong.'
				break
		}
	}

	const variable_set_value = (event) => {
		switch (event.detail.cmd) {
			case 'message':
				message = event.detail.value
				break

			case 'contact':
				contact = event.detail.value
				break
		}
	}

	const send_form = async () => {
		if (topic && !message) {
			errorMsg = true
			errorMessage = 'Please enter your information'
			toError = setTimeout(() => {
				errorMsg = false
			}, 2000)
			return
		}

		if (!topic) {
			errorTopic = true
			errorMessage = 'please select a topic'
			toError = setTimeout(() => {
				errorTopic = false
			}, 2000)
			return
		}

		const formData = {
			cmd: 'send_report',
			id: ID,
			topic: topic,
			message: message,
		}

		showShader = true

		const response = await admin(formData)

		showThank = true
		name = response
		toError = setTimeout(() => {
			showShader = false
			showThank = false
			close_window()
		}, 6000)
	}

	onDestroy(() => {
		clearTimeout(toError)
	})
</script>

<main transition:fade={{ duration: 500 }}>
	<div class="title" use:styles={{ fsL }}>CONTACT KYBO - TECH</div>
	<div class="row_title" use:styles={{ fsN }}>
		When it comes to large-scale projects, thorough testing is crucial to catch as many mistakes as possible.<br />
		However, due to the sheer complexity and size of these projects, it's not uncommon for some mistakes to slip through
		the cracks, even after extensive testing.
		<p>
			Should you experience any problems while using our builder, do not hesitate to contact us by filling in the form
			below.
		</p>
		<p>Use the form also to send feedback or to send some suggestions for future updates.</p>
	</div>

	{#if !errorTopic}
		<Select marginBottom="10px" options="feedback,suggestion,bug-report" on:select={set_topic} value="select topic" />
	{:else}
		<div class="component">
			<Error errorMessage="Please select a topic" errorType="textarea" />
		</div>
	{/if}

	<div class="divider" />
	{#if topic && topic.length > 0}
		<div class="row_title" use:styles={{ fsN }}>{messageTitle}</div>
		<div class="divider" />
		{#if !errorMsg}
			<div class="component">
				<Textarea
					on:input={variable_set_value}
					backgroundColor="transparent"
					safe="false"
					cmd="message"
					placeHolder="Message"
				/>
			</div>
		{:else}
			<div class="component">
				<Error errorMessage="Please enter a short description of your project" errorType="textarea" />
			</div>
		{/if}
	{/if}

	<div class="button_container">
		<Button
			on:click={send_form}
			title="send"
			fontSize={fsS}
			color={fontColor}
			{bg}
			hoverBackground="none"
			{hoverText}
			shadow="none"
		/>
	</div>

	{#if showShader}
		{#if !showThank}
			<div class="shader"><div class="shader"><Spinner color="hsl(0,0%,60%)" info="send message" /></div></div>
		{:else if showThank && !errorUser}
			<div class="shader">
				<div class="thank" use:styles={{ fontColor, inputBg, fsS, borderColor }}>
					<p>Dear {name}</p>
					Thank you for your feedback<br />If necessary we will contact you a.s.a.p.
					<p>your kybo-tech team</p>
				</div>
			</div>
		{/if}
	{/if}
</main>

<style>
	main {
		width: 80vw;
		padding: 15px;
		margin-left: 10vw;
	}

	.title {
		display: flex;
		justify-content: center;
		margin-bottom: 30px;
		width: 100%;
		color: white;
		font-size: var(--fsL);
	}
	.shader {
		display: flex;
		position: absolute;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
		height: 100vh;
		width: 100vw;
		background-color: hsla(0, 0%, 10%, 0.6);
	}

	.thank {
		color: var(--fontColor);
		font-size: var(--fsS);
		text-align: center;
		padding: 2%;
		background-color: var(--inputBg);
		border: 1px solid var(--borderColor);
	}

	.button_container {
		display: flex;
		justify-content: flex-end;
		margin-top: 2%;
		width: 100%;
	}

	.component {
		margin-bottom: 1%;
	}

	.row_title {
		color: white;
		font-size: var(--fsN);
	}

	.divider {
		margin: 20px 0 20px 0;
	}
</style>
